import React, { useRef, useState } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { DragType } from './dnd'
import Checkbox from '../Checkbox'

export default ({ checked, parcel, onCheck, onMoveItem }) => {
    const ref = useRef(null)
    const [isFocused, setIsFocused] = useState(false)

    const [{ isDragging }, drag] = useDrag({
        item: { type: DragType.Parcel, id: parcel.apn, ref },
        collect: monitor => ({ isDragging: !!monitor.isDragging() })
    })

    const [, drop] = useDrop({
        accept: [DragType.Parcel, DragType.Project],
        hover: (item, monitor) => {
            if (parcel.apn === item.id || parcel.parent === item.id) {
                return
            }
            const sourceRect = item.ref.current.getBoundingClientRect()
            const targetRect = ref.current.getBoundingClientRect()
            const { y } = monitor.getClientOffset()
            const direction = sourceRect.top > targetRect.top ? 'up' : 'down'
            const half = targetRect.top + (targetRect.bottom - targetRect.top) / 2

            if (direction === 'up' && y < half) {
                onMoveItem(item.id, parcel.apn, 'before')
            } else if (direction === 'down' && y > half) {
                onMoveItem(item.id, parcel.apn, 'after')
            }
        }
    })

    drag(drop(ref))

    return (
        <tr ref={ref} className={`${isDragging ? 'is-dragging' : ''} ${parcel.parent !== null ? 'indented' : ''}`}>
            <td>
                <Checkbox
                    checked={checked}
                    additionalClasses=""
                    onClick={onCheck}
                    aria-label="Checkbox to select this parcel"
                />
            </td>
            <td>{parcel.apn}</td>
            <td>{parcel.address.label}</td>
        </tr>
    )
}
